import ResourceNotFound from '@/pages/ResourceNotFound'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/resource-not-found')({
  component: ResourceNotFoundPage,
})

function ResourceNotFoundPage() {
  return <ResourceNotFound />
}
